export const links = {
    facebook: "https://www.facebook.com/RELIC-ensemble-109345125182475/",
    insta: "https://www.instagram.com/relic_ensemble/",
    youtube: "https://www.youtube.com/channel/UCo6idH2C9IkvGEjluWbOqZA",
    gems: "https://gemsny.thundertix.com/donations/new?campaign_id=2809",
    gemsWebsite: 'https://gemsny.org',
    ytSubscribe: 'http://www.youtube.com/channel/UCo6idH2C9IkvGEjluWbOqZA?sub_confirmation=1',
    zeffy: 'https://www.zeffy.com/en-US/donation-form/donate-to-relic-2',
    donorBox: 'https://donorbox.org/donate-to-relic?',
};